module.exports = __webpack_public_path__ + "img/error-icons.e99de5b5.svg";